import { unsafeCSS, html } from "lit";
import { LeafElement } from "../../components/leaf-element.js";
import { SlotController } from "../../utilities/slot.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n.base-c-value-prop-heading {\n  max-width: 850px;\n}\n.base-c-value-prop-heading .base-c-value-prop-heading--icon-container ::slotted([slot=icon]) {\n  --icon-height: var(--leafdcws-value-prop-heading-icon-height);\n  --icon-width: var(--leafdcws-value-prop-heading-icon-width);\n}\n\n::slotted([slot=heading]) {\n  margin-bottom: var(--leaf-spacing-48);\n}\n\n.base-c-value-prop-heading--content {\n  margin-bottom: var(--leaf-spacing-24);\n}";
const _BaseValuePropHeading = class _BaseValuePropHeading extends LeafElement {
  constructor() {
    super(...arguments);
    this.slotController = new SlotController(this);
  }
  render() {
    return html`<div class="base-c-value-prop-heading">
      <div class="base-c-value-prop-heading--header">
        ${this.slotController.hasNamedSlot("icon") ? html`
              <div class="base-c-value-prop-heading--icon-container">
                <slot name="icon"></slot>
              </div>
            ` : ``}
        <div class="base-c-value-prop-heading--heading">
          <slot name="heading"></slot>
        </div>
      </div>
      ${this.slotController.hasDefaultSlot() ? html`<div class="base-c-value-prop-heading--content">
            <slot></slot>
          </div>` : ``}
    </div>`;
  }
};
_BaseValuePropHeading.styles = unsafeCSS(styles);
let BaseValuePropHeading = _BaseValuePropHeading;
export {
  BaseValuePropHeading
};
//# sourceMappingURL=value-prop-heading.js.map
